import Vue, { DirectiveOptions } from 'vue'

import 'normalize.css'
import ElementUI from 'element-ui'
import SvgIcon from 'vue-svgicon'

import '@/styles/element-variables.scss'
import '@/styles/index.scss'
import '@/styles/theme.scss'
import '@/assets/binui-icon/iconfont.css'

import App from '@/App.vue'
import store from '@/store'
import { AppModule } from '@/store/modules/app'
import router from '@/router'
import i18n from '@/lang'

import '@/icons/components'
import '@/permission'
import * as directives from '@/directives'
import echarts from 'echarts'
import VueResource from 'vue-resource'
const { version } = require('../package.json')
// import { Print } from '@/plugs/print'
// import Print from 'vue-print-nb'
Vue.use(ElementUI, {
  size: AppModule.size, // Set element-ui default size
  i18n: (key: string, value: string) => i18n.t(key, value)
})
Vue.prototype.$echarts = echarts
console.log(version)
let localVersion = localStorage.getItem('version')
if (localVersion !== version) {
  localStorage.setItem('version', version)
  window.location.reload()
}
Object.keys(directives).forEach(key => {
  Vue.directive(key, (directives as { [key: string ]: DirectiveOptions })[key])
})
Vue.use(VueResource)
Vue.use(SvgIcon, {
  tagName: 'svg-icon',
  defaultWidth: '1em',
  defaultHeight: '1em'
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
